import { Box, Text } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";


export default function MenuItemComponent({ index, menuText, selected, clickHandler, Component, link, bgColor, slider }) {
    const history = useHistory()
     console.log(menuText);
    const menuClickHandler = () => {
        clickHandler(index)
        history.push(link)
    }
    return (
        <Box
            d={['none', 'none', 'none', 'flex']}
            width='100%'
            // pl={slider ? '2.75rem' : '0'}
            style ={{paddingLeft :slider ? '2.75rem' : '0', justifyContent:slider ? 'flex-start' : 'center' }}
            // justifyContent={slider ? 'flex-start' : 'center'}
            position='relative'
            alignItems='center'
            cursor='pointer'
            onClick={menuClickHandler}
        >
            <Box h='35px' left='0' position='absolute' borderRightWidth='5px' borderRightStyle='solid' borderRightColor={selected ? bgColor : 'transparent'} borderRightRadius='5px'></Box>
            <Component width='24px' height = '24px' fill = {selected ? bgColor : '#93a2ba'} stroke = {selected ? bgColor : '#93a2ba'} style={{ marginRight: slider ? '1rem' : '0' }} />
            {
                slider && 
                <Text
                color={selected ? bgColor : '#93a2ba'}
                opacity={slider ? '1' : '0'}
                style={{ fontFamily: 'Mulish, sans-serif', fontSize: slider ? '16px' : '0px'}}
                fontWeight='700'
                // fontSize={slider ? '16px' : '0px'}
                sx={{
                    '&::WebkitOpacity': slider ? '1':'0',
                }}
                transition='opacity 500ms ease'
            >
                {menuText}
            </Text>
            }
        </Box>
    )
}